import React from 'react';
import styles from './styles.module.css';

const WarningContainer = ({ type = 'warning', icon, heading, text, children }) => {
  return (
    <div className={`${styles.container} ${styles[type]}`}>
      <div className={styles.innerContainer}>
        <img className={styles.icon} src={icon} alt={`Icon for ${type} banner box`} />
        <div className={styles.textContainer}>
          {heading && <h4 className={styles.heading}>{heading}</h4>}
          {text && <p className={styles.text}>{text}</p>}
        </div>
      </div>
      {children}
    </div>
  );
};

export default WarningContainer;
